import { DefaultRoles } from '@banzai/data/auth';

const roleOrder = ['pending', DefaultRoles.User, DefaultRoles.Admin, DefaultRoles.Owner];

export function getHighestRole(...params: Array<string | undefined>): string | undefined {
  if (!params.length) {
    return;
  }

  const safeParams: Array<string> = params.filter(x => x) as Array<string>;

  let highestRole = -1;
  safeParams.forEach(role => {
    const index = roleOrder.indexOf(role);
    highestRole = Math.max(highestRole, index);
  });
  if (highestRole === -1) {
    return;
  }
  return roleOrder[highestRole];
}

export function isRoleHigherOrEqual(roleToCheck: string, roleToCheckAgainst: string) {
  return roleOrder.indexOf(roleToCheck) >= roleOrder.indexOf(roleToCheckAgainst);
}

export function getHighestAllowedRole(
  roles: Array<string>,
  allowedRoles: Array<string>
): string | undefined {
  const highestRole = getHighestRole.apply(getHighestRole, roles);
  if (!highestRole) {
    return;
  }

  return allowedRoles.find(x => isRoleHigherOrEqual(highestRole, x));
}
